import React from 'react';

const ToastNotification = ({ show, message, type, onClose }) => {
  if (!show) return null;

  return (
    <div 
      className="toast-container position-fixed top-0 end-0 p-3" 
      style={{ zIndex: 1100 }}
    >
      <div 
        className={`toast show align-items-center text-white bg-${type === 'success' ? 'success' : 'danger'} border-0`} 
        role="alert" 
        aria-live="assertive" 
        aria-atomic="true"
      >
        <div className="d-flex">
          <div className="toast-body">
            {message}
          </div>
          <button 
            type="button" 
            className="btn-close btn-close-white me-2 m-auto" 
            onClick={onClose}
          ></button>
        </div>
      </div>
    </div>
  );
};

export default ToastNotification;